/* eslint-disable jsx-a11y/no-autofocus */

import React from 'react'
import styled from 'styled-components'
import { Flex, Text } from 'pcln-design-system'
import Counter from '../Counter'
import Divider from '../Divider'

const StyledFlex = styled(Flex)`
  height: 52px;
`

export interface ITravelerLineItem {
  autoFocus?: boolean
  className?: string
  count?: number
  label: string
  max?: number
  min?: number
  subLabel?: string
  onChange: (count: number) => void
}

function TravelerLineItem({
  autoFocus,
  className,
  count,
  label,
  min,
  max,
  subLabel,
  onChange,
}: ITravelerLineItem) {
  return (
    <>
      <StyledFlex className={className} justifyContent='space-between' alignItems='center' width={1}>
        <Flex alignItems='center'>
          <Text fontSize={1} mr={1}>
            {label}
          </Text>
          <Text fontSize={1} color='text.light'>
            {subLabel}
          </Text>
        </Flex>
        <Counter autoFocus={autoFocus} label={label} min={min} max={max} count={count} onChange={onChange} />
      </StyledFlex>
      <Divider />
    </>
  )
}

export default TravelerLineItem
